import React, { useState } from 'react';

const SelectInput = ({ label, value, onChange, options, placeholder = '', className = '', style = {}, description }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ marginBottom: 8 }}>
      <label style={{ fontWeight: 'bold', marginBottom: 2, display: 'block' }}>{label}
        {description && (
          <button
            type="button"
            onClick={() => setOpen(o => !o)}
            style={{ marginLeft: 8, fontSize: '0.9em', background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', padding: 0 }}
          >
            {open ? '▲ 説明を閉じる' : '▼ 説明を見る'}
          </button>
        )}
      </label>
      {description && open && (
        <div style={{ background: '#f7f7f7', border: '1px solid #ddd', borderRadius: 4, padding: '6px 10px', margin: '4px 0 8px 0', fontSize: '0.95em', color: '#444' }}>
          {description}
        </div>
      )}
      <select
        value={value}
        onChange={onChange}
        className={className}
        style={style}
      >
        <option value="">{placeholder}</option>
        {options.map(opt => (
          <option key={opt.id} value={opt.id}>{opt.name}</option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput;
